import React from 'react';
import './CtaBanner.css';

export default function CtaBanner() {
  return (
    <div className="cta-banner text-white text-center py-5">
      <h2 className="mb-3">🎉 Join Demo Classes for Just ₹19/-</h2>
      <p className="mb-4">Experience live learning with expert teachers before you commit.</p>
      <button className="btn btn-light btn-lg">Join Now</button>
    </div>
  );
}
